import { mdTenantID } from 'ihub/common';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import GlobalAppContext from '../../components/custom-controls/local-selector/global-app-context';
import AppRoutes from '../../enums/app-routes';
import {
	GetAccessToken,
	GetPasswordReset,
	userHasPermissions,
} from '../../functions/session-functions';
import ProtectedRouteProps from './protected-route-props';
import TourProviderWrapper from '../../contexts/tour-provider/tour-provider-context';

const ProtectedRoute = ({
	children,
	action,
	subject,
}: Readonly<ProtectedRouteProps>): React.JSX.Element => {
	const { tenant } = useContext(GlobalAppContext);
	if (!GetAccessToken()) {
		return <Navigate to={AppRoutes.Login} replace />;
	}
	if (
		!(
			window.location.href.includes(AppRoutes.ProfileDashboard()) ||
			window.location.href.includes(AppRoutes.MfaScreen())
		) &&
		GetPasswordReset()
	) {
		return <Navigate to={AppRoutes.ProfileDashboard()} replace />;
	}
	if (!window.location.href.includes(AppRoutes.Unauthorized()) && !tenant) {
		window.sessionStorage.removeItem('snackbar-storage');
		return <Navigate to={AppRoutes.Unauthorized()} replace />;
	}
	if (window.location.href.includes(AppRoutes.TenantManagement()) && tenant !== mdTenantID) {
		return <Navigate to={AppRoutes.Root} replace />;
	}
	if (window.location.href.includes(AppRoutes.Settings) && tenant !== mdTenantID) {
		return <Navigate to={AppRoutes.Root} replace />;
	}
	if (subject && action) {
		if (userHasPermissions(subject, action)) {
			return <TourProviderWrapper>{children}</TourProviderWrapper>;
		} else {
			//This should be empty to make sure the item with missing permissions does not render
			return <></>;
		}
	}
	return <TourProviderWrapper>{children}</TourProviderWrapper>;
};

export default ProtectedRoute;
